import { REAL_ESTATE_USAGES } from 'cpool-constants';

import type { SchemaRealEstatesForm } from '~/features/leadDetails/schemas/realEstates.schema';

export type RealEstate = SchemaRealEstatesForm['immobilien'][number];
export type BuildingDescription = NonNullable<RealEstate['baubeschreibung']>;

type RealEstateBuildingDescriptionSource = Partial<
    Pick<RealEstate, 'baubeschreibung' | 'nutzungsart' | 'vermieteteWohnflaeche' | 'wert' | 'wohnflaeche'>
>;

function getExternallyUsedLivingSpace(realEstate: RealEstateBuildingDescriptionSource): number | null {
    if (realEstate.nutzungsart === REAL_ESTATE_USAGES.VERMIETET) {
        return realEstate.wohnflaeche ?? null;
    }
    if (realEstate.nutzungsart === REAL_ESTATE_USAGES.EIGENGENUTZT_UND_VERMIETET) {
        return realEstate.vermieteteWohnflaeche ?? null;
    }
    return null;
}

export const syncBuildingDescriptionFromRealEstate = ({
    baubeschreibung,
    realEstate,
}: {
    baubeschreibung: BuildingDescription;
    realEstate: RealEstateBuildingDescriptionSource;
}): BuildingDescription => ({
    ...baubeschreibung,
    anschriftUndObjektart: {
        ...baubeschreibung.anschriftUndObjektart,
        fremdgenutzteWohnflaeche: getExternallyUsedLivingSpace(realEstate),
        geschaetzterWert: realEstate.wert ?? null,
        wohnflaeche: realEstate.wohnflaeche ?? null,
    },
});

export const syncRealEstateBuildingDescription = <T extends RealEstateBuildingDescriptionSource>(realEstate: T): T =>
    realEstate.baubeschreibung == null
        ? realEstate
        : {
              ...realEstate,
              baubeschreibung: syncBuildingDescriptionFromRealEstate({
                  baubeschreibung: realEstate.baubeschreibung,
                  realEstate,
              }),
          };

export const syncRealEstateBuildingDescriptions = (data: SchemaRealEstatesForm): SchemaRealEstatesForm => ({
    immobilien: data.immobilien.map(syncRealEstateBuildingDescription),
});
